<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <div v-if="created" class="alert alert-success" role="status">{{ created.name }} {{$t('notifications.created')}}.</div>
          <div v-if="updated" class="alert alert-success" role="status">{{ updated.name }} {{$t('notifications.updated')}}.</div>
          <div v-if="isLoading || deleteLoading" class="alert alert-info" role="status">{{$t('notifications.loading')}}...</div>
          <div v-if="error" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}
          </div>
          <div v-if="deleteError" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ deleteError }}
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <router-link v-if="item" :to="{ name: 'EXSBPricGgroupList' }" class="btn btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
<!--          <button class="btn btn-danger" @click="del">{{ $t('buttons.delete') }}</button>-->
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXSBPriceGroupForm
                          v-if="item"
                          :handle-submit="onSendForm"
                          :handle-update-field="updateField"
                          :values="item"
                          :errors="violations"
                          :initial-values="retrieved" />
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXSBPriceGroupForm from './Form.vue'
import { checkPagePermission } from '@/utils/checkRoles.js'

export default {
  components: {
    EXSBPriceGroupForm
  },

  data () {
    return {
      item: {}
    }
  },

  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBPriceGroupUpdate')
  },

  computed: {
    ...mapGetters({
      isLoading: 'exsbpricegroup/update/isLoading',
      error: 'exsbpricegroup/update/error',
      deleteError: 'exsbpricegroup/del/error',
      deleteLoading: 'exsbpricegroup/del/isLoading',
      created: 'exsbpricegroup/create/created',
      deleted: 'exsbpricegroup/del/deleted',
      retrieved: 'exsbpricegroup/update/retrieved',
      updated: 'exsbpricegroup/update/updated',
      violations: 'exsbpricegroup/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXSBPriceGroupList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'exsbpricegroup/create/reset',
      deleteItem: 'exsbpricegroup/del/del',
      delReset: 'exsbpricegroup/del/reset',
      retrieve: 'exsbpricegroup/update/retrieve',
      updateReset: 'exsbpricegroup/update/reset',
      update: 'exsbpricegroup/update/update',
      updateRetrieved: 'exsbpricegroup/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this exsbpricegroup ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
